/**
 * description 资源中心详情页文字云
 * created by he.zhikai
 * created on 2017-12-13
 */
"use strict";
angular.module("wordCloudModule", []).
directive("wordCloud", ["$timeout", "$interval", function($timeout, $interval) {
    return {
        replace: true,
        scope: {
            mainCloudData: "=", //核心数据
            subCloudData: "=", //边缘数据
            cloudColor: "@", //文字颜色
        },
        restrict: 'E',
        templateUrl: "./resourceCenter/detail/wordCloudDir/wordCloud_tpl.html",
        link: function($scope, $element, iAttrs) {
            initStatus();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                //核心数据所在元素
                $scope.mainEle = $element.find(".main_cloud");
                $scope.mainEle.css({
                    "height": $scope.mainEle.width() + "px",
                    // "background-color": $scope.cloudColor,
                    "color": $scope.cloudColor,
                    "top": ($element.height() - $scope.mainEle.width()) / 2 + "px"
                });
                $timeout(function() {
                    //边缘数据所在元素
                    $scope.subEle = $element.find(".sub_cloud");
                    $scope.subEle.css({
                        "color": $scope.cloudColor
                    });
                    // startWave();
                }, 500);
            }

            /**
             * [startWave description] 开始浮动
             * @return {[type]} [description]
             */
            function startWave() {
                autoWave();
                $scope.autoWaveInterval = $interval(autoWave, 2000);
                $scope.$on('$destroy', function() {
                    $interval.cancel($scope.autoWaveInterval);
                });
            }

            /**
             * [autoWave description] 自动浮动
             * @return {[type]} [description]
             */
            function autoWave() {
                $scope.mainEle.css({
                    "transform": "translate(" + getRandom() + "px," + getRandom() + "px)"
                });
                angular.forEach($scope.subCloudData, function(data, index) {
                    $scope.subEle.eq(index).css({
                        "transform": "translate(" + getRandom() + "px," + getRandom() + "px)"
                    });
                });
            }

            /**
             * [getRandom description] 获取位置偏差随机数
             * @return {[type]} [description]
             */
            function getRandom() {
                var value = Math.random() * 10;
                return Math.random() > 0.5 ? value : -value;
            }
        }
    };
}]);